import { render, staticRenderFns } from "./PlaylistInfoBox.vue?vue&type=template&id=2b232db9&scoped=true&"
import script from "./PlaylistInfoBox.vue?vue&type=script&lang=js&"
export * from "./PlaylistInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistInfoBox.vue?vue&type=style&index=0&id=2b232db9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b232db9",
  null
  
)

export default component.exports